import { render, staticRenderFns } from "./ResetPassRequest.vue?vue&type=template&id=5aea96c2&scoped=true"
import script from "./ResetPassRequest.vue?vue&type=script&lang=js"
export * from "./ResetPassRequest.vue?vue&type=script&lang=js"
import style0 from "./ResetPassRequest.vue?vue&type=style&index=0&id=5aea96c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aea96c2",
  null
  
)

export default component.exports